 <template>
  <div>

    <div v-if="jobType=='input'">
      <!-- Pen modal -->
      <div class="modal-overlay" v-if="setModals.modalpen">
        <div class="modal-content modalLightGray">
          <InModalPen></InModalPen>
        </div>
      </div>
      <!-- Pc modal -->
      <div class="modal-overlay" v-if="setModals.modalpc">
        <InModalPc></InModalPc>
      </div>
      <!-- Kit modal -->
      <div class="modal-overlay" v-if="setModals.modalkit">
        <InModalKit></InModalKit>
      </div>
    </div>

    <!-- CAMERA SW -->
    <b-row>
      <b-col>
      <div class="row">
          <div class="camerasw">
          <b-button-group>
              <b-button id="camerasw1" :variant="mbtnvariant1" size="sm" type=button class="camerasw-cls" @click="swCamera(0)">
                <b-icon icon="cursor"></b-icon> Drw
              </b-button>
              <b-button id="camerasw2" :variant="mbtnvariant2" size="sm" type=button class="camerasw-cls" @click="swCamera(1)">
                <b-icon icon="display"></b-icon> PC
              </b-button>
              <b-button id="camerasw3" :variant="mbtnvariant3" size="sm" type=button class="camerasw-cls" @click="swCamera(2)">
                <b-icon icon="camera-video"></b-icon> Kit
              </b-button>
          </b-button-group>
          </div>
          <!-- Set Kit IP-Address -->
          <b-input-group prepend="Kit-IP" size="sm" class="inputip" v-show="(jobType=='input' && cameraInput=='kit') || (jobType=='predict' && cameraPredict=='kit')">
          <b-form-input v-model="kitaddr" :state="setKits.ipstate" placeholder="192.168.x.xxx" ></b-form-input>
          </b-input-group>
      </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import InModalKit from '@/components/InModalKit.vue'
import InModalPc from '@/components/InModalPc.vue'
import InModalPen from '@/components/InModalPen.vue'

export default {
  name: 'inmanualsw',
  props: {
    jobType: { type: String, default: 'input' }
  },
  data () {
    return {
    }
  },
  components: {
    InModalKit,
    InModalPc,
    InModalPen
  },
  computed: {
    ...mapState([ 'cameraInput', 'cameraPredict', 'setModals', 'setKits' ]),
    mbtnvariant1 () {
      if ((this.jobType === 'input' && this.cameraInput === 'pen') || (this.jobType === 'predict' && this.cameraPredict === 'pen')) {
        return 'primary'
      } else {
        return 'outline-primary'
      }
    },
    mbtnvariant2 () {
      if ((this.jobType === 'input' && this.cameraInput === 'pc') || (this.jobType === 'predict' && this.cameraPredict === 'pc')) {
        return 'primary'
      } else {
        return 'outline-primary'
      }
    },
    mbtnvariant3 () {
      if ((this.jobType === 'input' && this.cameraInput === 'kit') || (this.jobType === 'predict' && this.cameraPredict === 'kit')) {
        return 'primary'
      } else {
        return 'outline-primary'
      }
    },
    kitaddr: {
      get () {
        return this.setKits.kitip
      },
      set (value) {
        const checkFlag = Boolean(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value))
        this.$store.dispatch('setKitIp', {
          s_ip: value,
          s_st: checkFlag
        })
      }
    }
  },
  methods: {
    swCamera (swFlag) {
      // console.log('do swCamera')
      if (swFlag === 0) {
        this.$store.dispatch('cameraSw', {jobType: this.jobType, swFlag: 0})
      } else if (swFlag === 1) {
        this.$store.dispatch('cameraSw', {jobType: this.jobType, swFlag: 1})
      } else {
        this.$store.dispatch('cameraSw', {jobType: this.jobType, swFlag: 2})
      }
    }
  }
}
</script>

<style scoped>
.modalLightGray {
  background: #eee;
}
.camerasw {
  padding: 0 0 0 15px;
  width: 150px;
  height: 40px;
}
.camerasw-cls {
  padding: 0;
  margin: 0;
  width: 50px;
  height: 30px;
}
.inputip {
  text-align: center;
  margin: 0 0 10px 16px;
  width: 185px;
}
</style>



// WEBPACK FOOTER //
// src/components/InManualSw.vue